import React, { useCallback, useMemo } from 'react'
import {  TextInfo } from '../../../components/text'
import ReviewPrivateSolicitor from '../../application-coo-stage-b/review-endorse/review-private-solicitor'
import { P2Accordion, P2Checkbox, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script'
import { SolicitorTypeEnum } from '../../../models/enum/solicitor-type.enum';
import ReviewHdbSolicitor from '../../application-coo-stage-b/review-endorse/review-hdb-solicitor';
import { conveyancingSolicitorTypeItems, proposedHousingTypeItems, solicitorTypeItems } from '../../../utils/shared-dropdown';
import { Dropdown } from '../../../components/dropdown';
import PrivateSolicitorForm from '../../../components/HOC/private-solicitor-form/private-solicitor-form';
import HdbSolicitorForm from '../../../components/HOC/hdb-solicitor-form/hdb-solicitor-form';
import { StageBConveyancing, StageBDocumentation, StageBPersonalDetail } from '../../../models/classes/stage-b/review-endorse.class';
import { ApplicationStep3, HDBSolicitor, LegalRepresentation, PrivateSolicitor } from '../../../models/classes/ApplicationStep3.class';
import { Separator } from '../../../components/separator';
import HoldingTypeSegment from '../segments/holding-type.segment';
import ReviewConveyancingDocument from '../../application-coo-stage-b/review-endorse/review-conveyancing-document';
import LegalRepresentationSegment from '../conveyancing/legal-representation-segment';
import { HoldingTypeEnum } from '../../../models/enum/holding-type.enum';
import ValuationStampDutyForm from '../../../components/HOC/valuation-stamp-duty-form/valuation-stamp-duty-form';
import { LoanTypeEnum } from '../../../models/enum/loan-type.enum';
import { ApplicationStep2 } from '../../../models/classes/ApplicationStep2.class';
import TenancyInCommonTable from './tenancy-in-common-table';
import { DocumentItem } from '../../../models/polymer/Document.model';
import { ApplicationStep1 } from '../../../models/classes/ApplicationStep1.class';
import { OwnershipReasonEnum } from '../../../models/enum/ownership-reason.enum';
import moment from 'moment';
import useGetEligibilityOverride from '../../../hooks/use-get-eligibility-override'
import { useAppSelector } from '../../../redux/hook';

interface ReviewConveyancingProps {
  isLoginOutgoing: boolean;
  isMainOutgoing: boolean;
  isSoleOwnership: boolean;
  conveyancing_values: StageBConveyancing;
  personal_values: StageBPersonalDetail;
  documentation_values: StageBDocumentation;
  financial_values: ApplicationStep2;
  setFormValue: React.Dispatch<React.SetStateAction<StageBConveyancing>>;
  SetDocumentationValue: React.Dispatch<React.SetStateAction<StageBDocumentation>>;
  errors:any;
  displayValuation: boolean;
  isDocumentRequested: boolean;
  documentList:DocumentItem[];
  updateLastWillIsChecked:(additionalCheckbox: string[]) => void;
  processSameProposedOwner:() => void;
  isCurrentDirectConveyancing: boolean;
  isProposedDirectConveyancing: boolean;
  applicationStep1FormData: ApplicationStep1;
  isMainApplicantCreateApplication?: boolean;
  differentOutgoingOwnerSolicitorNotSelected: boolean;
  processOutgoingDifferentSolicitor: () => void;
  forceError?: boolean;
  forceErrorDocuments?: boolean;
  uinfin?: string;
  singpassToken?: string;
  applicationId?: string;
}

function ReviewConveyancing({ ...props }: ReviewConveyancingProps) {
  
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const isLoginOutgoing = props.isLoginOutgoing;

  const isMainRetaining = !props.isMainOutgoing;
  const isMainOutgoing = props.isMainOutgoing;

  const isPrivate = props.conveyancing_values.current_solicitor_type === SolicitorTypeEnum.private_solicitor;
  const isHDB = props.conveyancing_values.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor;
  const isProposedHDB = props.conveyancing_values.proposed_solicitor_type === SolicitorTypeEnum.hdb_solicitor;
  const isProposedPrivate = props.conveyancing_values.proposed_solicitor_type === SolicitorTypeEnum.private_solicitor;
  const { bypassSolicitors } = useGetEligibilityOverride(applicationStartFormData.selected_hdb_property?.hdb_ref);

  const enableProposeSameSolicitor = useMemo(()=>{
    if(!!!props.financial_values.new_loan_type || (props.conveyancing_values.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor && props.financial_values.new_loan_type === LoanTypeEnum.bank_loan) || (!(props.conveyancing_values.current.private_solicitor.is_confirm || props.conveyancing_values.current.hdb_solicitor.is_confirm)) || (!props.conveyancing_values.current_solicitor_type) || ((!props.conveyancing_values.current.private_solicitor.represented_same_solicitor && !props.conveyancing_values.current.conveyancing_private_solicitor.is_confirm) && props.conveyancing_values.current_solicitor_type === SolicitorTypeEnum.private_solicitor) || ((!props.conveyancing_values.current.hdb_solicitor.represented_same_solicitor && !props.conveyancing_values.current.conveyancing_private_solicitor.is_confirm) && props.conveyancing_values.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor)){
      //disabled it when private or hdb solicitor not confirm
      return false;
    }
    return true;

  },[props.conveyancing_values, props.financial_values.new_loan_type]);

  
  const getAdditionalCheckbox = (additionalCheckbox: string[]) => {
    props.updateLastWillIsChecked(additionalCheckbox);
  }

  const processLegalRepresentationDropdown = useMemo(()=>{
    if(bypassSolicitors.proposed === true){
      return props.isProposedDirectConveyancing ? conveyancingSolicitorTypeItems : solicitorTypeItems;
    }

    const privateSolicitorOnly = props.isProposedDirectConveyancing ? conveyancingSolicitorTypeItems.filter(e=>e.value === SolicitorTypeEnum.conveyancing_private_solicitor) : solicitorTypeItems.filter(e=>e.value === SolicitorTypeEnum.private_solicitor);

    if(props.financial_values.new_loan_type === LoanTypeEnum.bank_loan){
      return privateSolicitorOnly;
    }
    else if(props.conveyancing_values.attend_hdb_in_person === false){
      return privateSolicitorOnly;
    } 
    else if(props.applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.divorce){
      if(props.applicationStep1FormData.reason.submit_content === false || props.applicationStep1FormData.reason.date_of_court_order <= moment().add({months: 3}).format('yyyy-MM-DD')){
        return privateSolicitorOnly;
      }
    }
    else if(props.applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.demise_of_current_owner){
      if(props.applicationStep1FormData.reason.is_beneficiary_proposed_owners === "false"){
          return privateSolicitorOnly;
      }
    }

    return props.isProposedDirectConveyancing ? conveyancingSolicitorTypeItems : solicitorTypeItems

  },[props.applicationStep1FormData.reason.change_ownership_reason, props.applicationStep1FormData.reason.date_of_court_order, props.applicationStep1FormData.reason.is_beneficiary_proposed_owners, props.applicationStep1FormData.reason.submit_content, props.conveyancing_values.attend_hdb_in_person, props.financial_values.new_loan_type, props.isProposedDirectConveyancing, bypassSolicitors])

  const processLegalRepresentationDropdownForOutgoing = useMemo(()=>{
    const privateSolicitorOnly = conveyancingSolicitorTypeItems.filter(e=>e.value === SolicitorTypeEnum.conveyancing_private_solicitor);
    const isCurrentConveyancingHdb = props.conveyancing_values.current_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor || (props.conveyancing_values.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor && props.conveyancing_values.current.hdb_solicitor.represented_same_solicitor);
    const isDivorce = props.applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.divorce;
    const isSubmitContent =  props.applicationStep1FormData.reason.submit_content;
    const dateOfCourtOrderCheck =  props.applicationStep1FormData.reason.date_of_court_order <= moment().add({months: 3}).format('yyyy-MM-DD');
    if (isDivorce && (isSubmitContent === false || dateOfCourtOrderCheck)) {
      return privateSolicitorOnly;
    }

    const isDemise = props.applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.demise_of_current_owner;
    const isNotBeneficiary = props.applicationStep1FormData.reason.is_beneficiary_proposed_owners === "false";
    if(isDemise && isNotBeneficiary){
      return privateSolicitorOnly;
    }

    if (props.financial_values.current_loan_type === LoanTypeEnum.bank_loan && Number(props.financial_values.current_loan_amount) > 0) {
      return privateSolicitorOnly;
    }

    if(props.conveyancing_values.attend_hdb_in_person === false){
      return privateSolicitorOnly;
    } 

    if(isCurrentConveyancingHdb){
      return privateSolicitorOnly;
    }

    return conveyancingSolicitorTypeItems;

  }, [props.applicationStep1FormData, props.financial_values, props.conveyancing_values])

  const handleProposedHoldingType = useCallback((value:any)=>{
    props.setFormValue({...props.conveyancing_values, holding_type:value});
  },[props]);
  

  const handleMortgageSolicitor = useCallback((value:any)=>{
      const proposed = new LegalRepresentation({ ...props.conveyancing_values.proposed });
      proposed.private_solicitor.is_confirm = false;
      if (value !== SolicitorTypeEnum.hdb_solicitor) {
        proposed.hdb_solicitor = new HDBSolicitor({});
        proposed.is_conveyancing_hdb = false;
      } else {
        proposed.hdb_solicitor.is_confirm = false;
      }
      props.setFormValue({
        ...props.conveyancing_values,
        proposed_solicitor_type: value,
        proposed,
      });
  },[props])

  const handleOutgoingConveyancingSolicitor = useCallback((value:any)=>{
    const outgoing = new LegalRepresentation({ ...props.conveyancing_values.outgoing });
    outgoing.private_solicitor.is_confirm = false;
    if (value !== SolicitorTypeEnum.hdb_solicitor) {
      outgoing.hdb_solicitor = new HDBSolicitor({});
      outgoing.is_conveyancing_hdb = false;
    } else {
      outgoing.hdb_solicitor.is_confirm = false;
    }
    props.setFormValue({
      ...props.conveyancing_values,
      outgoing_solicitor_type: value,
      outgoing,
    });
  },[props])

  const handleConveyancingSolicitor = useCallback((legal_representation:LegalRepresentation)=>{
    props.setFormValue({...props.conveyancing_values, ...legal_representation});
  },[props])
  
  const handleConveyancingSolicitorType = useCallback((e:any)=>{
    const proposed = new LegalRepresentation({ ...props.conveyancing_values.proposed });
    if (e !== SolicitorTypeEnum.hdb_solicitor) {
      proposed.hdb_solicitor = new HDBSolicitor({});
      proposed.is_conveyancing_hdb = false;
    }
    props.setFormValue({ ...props.conveyancing_values, proposed_solicitor_type: e, proposed });
  },[props])


  const conveyancingSolicitorComponent = useCallback((type: "current" | "proposed")=>{
    
    const hdbConveyancing = (props.conveyancing_values[`${type}_solicitor_type`] === SolicitorTypeEnum.hdb_solicitor && props.conveyancing_values[type].hdb_solicitor.represented_same_solicitor === false && props.conveyancing_values[type].conveyancing_private_solicitor.is_confirm === true);
    const privateConveyancing = props.conveyancing_values[`${type}_solicitor_type`] === SolicitorTypeEnum.private_solicitor;
    const directPrivateConveyancing = props.conveyancing_values[`${type}_solicitor_type`] === SolicitorTypeEnum.conveyancing_private_solicitor;
    const directHDBConveyancing = props.conveyancing_values[`${type}_solicitor_type`] === SolicitorTypeEnum.conveyancing_hdb_solicitor;
    
    const hasConveyancing = hdbConveyancing || privateConveyancing || directPrivateConveyancing || directHDBConveyancing;

    if(!hasConveyancing){
      return <></>
    }

    const conveyancingSolicitorName = directHDBConveyancing ? "HDB" : props.conveyancing_values[type].conveyancing_private_solicitor.name_of_firm;
    return (
      <div className='mt-4 d-flex flex-column gap-3'>
        <TextInfo variant='column' title={`Legal representation for ${type === "current" ? 'Current' : 'Proposed'} Owners' conveyancing`} description={
          <div style={{ marginTop: 5 }}>
            {conveyancingSolicitorName}
          </div>
        } />
      </div>
    )
  },[props.conveyancing_values])


  const conveyancingDisabledField = useMemo(()=>{
    if((props.conveyancing_values.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor && props.conveyancing_values.proposed.hdb_solicitor.is_confirm) || (props.conveyancing_values.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor && props.conveyancing_values.proposed.conveyancing_private_solicitor.is_confirm)){
      return true;
    }
    return false;
  },[props.conveyancing_values.proposed.conveyancing_private_solicitor.is_confirm, props.conveyancing_values.proposed.hdb_solicitor.is_confirm, props.conveyancing_values.proposed_solicitor_type])

  const showConveyancingDropdownForProposed = useMemo(() => {
    if(bypassSolicitors.proposed === true && props.conveyancing_values.proposed_solicitor_type === SolicitorTypeEnum.private_solicitor && !props.conveyancing_values.proposed.private_solicitor.represented_same_solicitor && props.conveyancing_values.proposed.private_solicitor.is_confirm) {
        return true;
    }
    
    return false;
  }, [bypassSolicitors.proposed, props.conveyancing_values])
  
    const handleSelectProposedSolicitor = useCallback((e: any) => {
      const proposed = new LegalRepresentation({ ...props.conveyancing_values.proposed });
      if (e !== SolicitorTypeEnum.hdb_solicitor) {
        proposed.hdb_solicitor = new HDBSolicitor({});
        proposed.is_conveyancing_hdb = false;
      }
      props.setFormValue({ ...props.conveyancing_values, proposed_solicitor_type: e, proposed });
    },[props.conveyancing_values, props.setFormValue])
  
    const handleSelectProposedConveyancingSolicitor = useCallback((e: any) => {
      const isHdbConveyancing = e === SolicitorTypeEnum.hdb_solicitor;
      props.setFormValue({
        ...props.conveyancing_values,
        proposed: new LegalRepresentation({
          ...props.conveyancing_values.proposed,
          is_conveyancing_hdb: isHdbConveyancing,
          hdb_solicitor: new HDBSolicitor(isHdbConveyancing ? { ...props.conveyancing_values.proposed.hdb_solicitor } : {}),
          conveyancing_private_solicitor: new PrivateSolicitor(isHdbConveyancing ? {} : { ...props.conveyancing_values.proposed.conveyancing_private_solicitor }),
        }),
      });
    }, [props.conveyancing_values, props.setFormValue])

  if((props.isMainApplicantCreateApplication || isMainRetaining) && !isLoginOutgoing){
    //Additional created application no need to ask twice. just display the proposed info
    return <>
      <div className='px-4 pt-4 pb-5'>
        <p hidden aria-hidden>additional role create</p>
        <P2TextDescription color='#000' title='Conveyancing' />
        <div className='mt-4 d-flex flex-column gap-3'>
          <TextInfo variant='column' title={"Proposed Holding Type"} description={
            <>
              <div style={{ marginTop: 5 }}>
                {props.conveyancing_values.holding_type === HoldingTypeEnum.sole_ownership && "Sole Ownership"}
                {props.conveyancing_values.holding_type !== HoldingTypeEnum.sole_ownership && proposedHousingTypeItems.find(e=>e.value === props.conveyancing_values.holding_type)?.title}
              </div>
              {props.conveyancing_values.holding_type === HoldingTypeEnum.tenancy_in_common && <TenancyInCommonTable tenancyData={props.conveyancing_values.tenancy_in_common}/>}
            </>
          } />
        </div>
        {/* remove legal representation of proposed mortgage loan when not private and hdb loan */}
        {!(!isPrivate && !isHDB) && !props.isProposedDirectConveyancing && <div className='mt-4 d-flex flex-column gap-3'>
          <TextInfo variant='column' title={"Legal representation for Proposed Owners' new mortgage loan"} description={
            <div style={{ marginTop: 5 }}>
              {isProposedPrivate && <ReviewPrivateSolicitor private_solicitor={props.conveyancing_values.proposed.private_solicitor}/>}
              {isProposedHDB && <ReviewHdbSolicitor/>}
            </div>
          } />
        </div>}
        {conveyancingSolicitorComponent('proposed')}
      </div>
      {props.isDocumentRequested && <>
        <Separator variant='solid'/>
        <ReviewConveyancingDocument forceError={props.forceErrorDocuments} getAdditionalCheckbox={getAdditionalCheckbox} required_document_list={props.documentList} documentation_values={props.documentation_values} SetDocumentationValue={props.SetDocumentationValue} 
        applicationId={props.applicationId}
        singpassToken={props.singpassToken}
        uinfin={props.uinfin}
        />
      </>}
    </>
  }
  

  //when main applicant is outgoing and login user are retaining/incoming, filling up proposed info
  if(isMainOutgoing && !isLoginOutgoing){

    const currentSolicitorType = props.conveyancing_values.current_solicitor_type;
    const selectedSolicitorTypeItem = solicitorTypeItems.find(e => e.value === currentSolicitorType);
    const selectedConveyancingSolicitorTypeItem = conveyancingSolicitorTypeItems.find(e => e.value === currentSolicitorType);

    const selectedSolicitorTypeTitle = selectedSolicitorTypeItem?.title;
    const selectedConveyancingSolicitorTypeTitle = selectedConveyancingSolicitorTypeItem?.title;

    const isPrivateLawyer = (title: any) => title === "Private Lawyer";

    const getSelectedSolicitorType = () => {
      if (selectedSolicitorTypeTitle !== undefined) {
        return isPrivateLawyer(selectedSolicitorTypeTitle)
          ? props.conveyancing_values.current.private_solicitor.name_of_firm
          : selectedSolicitorTypeTitle;
      } else {
        return isPrivateLawyer(selectedConveyancingSolicitorTypeTitle)
          ? props.conveyancing_values.current.conveyancing_private_solicitor.name_of_firm
          : selectedConveyancingSolicitorTypeTitle;
      }
    };
    const result = getSelectedSolicitorType();

    return <>
      <p hidden aria-hidden>2</p>
      <div className='px-4 pt-4 pb-5'>
        <P2TextDescription color='#000' title='Conveyancing' />
        <div className='mt-4 d-flex flex-column gap-3'>
          <TextInfo variant='column' title={`Legal representation for Current Owners' ${props.isCurrentDirectConveyancing ? "conveyancing process" : "discharge of current loan"}`} description={
            <div style={{ marginTop: 5 }}>
              {result}
            </div>
          } />
        </div>
        
        <Separator variant="dashed" style={{margin:"32px 0"}}/>
          {/* FOR SOLE OWNERSHIP ONLY */}
          {props.isSoleOwnership && <>
            <TextInfo variant='column' title={"Proposed Holding Type"} description={
                <div style={{ marginTop: 5 }}>
                  Sole Ownership
                </div>
              } />
          </>}
          {/* FOR NON-SOLE OWNERSHIP, then show dropdown to selection proposed holding type */}
          {!props.isSoleOwnership && <>
            <Dropdown forceError={props.forceError} disabled={props.conveyancing_values.is_holding_type_confirm} style={{marginTop:32, fontWeight:700}} setSelectedDropdown={handleProposedHoldingType} selectedDropdown={props.conveyancing_values.holding_type} label='Proposed Holding Type' placeholder='Please indicate holding type' required items={proposedHousingTypeItems}/>
            
            {props.conveyancing_values.holding_type && <div className='pt-4'>
              <HoldingTypeSegment holding_type={props.conveyancing_values.holding_type} ConveyancingSetFormValue={props.setFormValue} ConveyancingValue={new ApplicationStep3({...props.conveyancing_values})} ConveyancingErrors={props.errors}/>
            </div>}
          </>}
        <Separator variant="dashed" style={{margin:"32px 0"}}/>

        <P2TextLabel bold="700" color={"#000"} label={"Legal Representation for Proposed Owners"}/>
        <>
          {/* To hide checkbox when not in used, requested by jesslyn in whatsapp on March 10,2024*/}
          {(enableProposeSameSolicitor && !(props.isProposedDirectConveyancing || props.isCurrentDirectConveyancing)) && <div className='mt-3'>
            <P2Checkbox variant={enableProposeSameSolicitor ? "default" : "disabled"} isActive={props.conveyancing_values?.proposed_same_solicitor} onClick={props.processSameProposedOwner} description={<P2TextLabel required label={<span style={{fontSize:"1rem"}} className='m-0'>Proposed Owners are represented by the same lawyer as above.</span>} />} />
          </div>}

          <div className='mt-4'>
            <Dropdown forceError={props.forceError} disabled={props.conveyancing_values?.proposed_same_solicitor || conveyancingDisabledField} tooltipContent={<span style={{color: "#212529", lineHeight: "1.5rem", fontSize: "1rem"}}>You would be required to engage a lawyer for the following,<div>1) Discharge of current mortgage loan</div><div>2) Obtaining fresh mortgage loan</div><div>3) Conveyancing for the ownership change (current owners)</div><div>4) Conveyancing for the ownership change (proposed owners)</div><br /><div>The change in flat ownership is a conveyancing process. As a recommendation, having the same lawyer acting for the process would expedite and reduce the liaising with multiple parties.</div></span>} hasTooltip setSelectedDropdown={handleMortgageSolicitor} selectedDropdown={props.conveyancing_values.proposed_solicitor_type} label={props.isProposedDirectConveyancing ? `Legal representation for Proposed Owners' conveyancing` : `Legal representation for Proposed Owners' new mortgage loan:`} placeholder='Please indicate lawyer type' required items={processLegalRepresentationDropdown}/>
          </div>
        </>
        <div style={{margin:"16px 0 0"}}>
          {!props.conveyancing_values.proposed_same_solicitor && (
            <LegalRepresentationSegment
              handleConveyancingSelection={handleSelectProposedConveyancingSolicitor}
              showConveyancingDropdown={showConveyancingDropdownForProposed}
              user_type={"proposed"}
              legalRepresentation={props.conveyancing_values.proposed}
              solicitor_type={props.conveyancing_values.proposed_solicitor_type}
              ConveyancingSetFormValue={props.setFormValue}
              ConveyancingErrors={props.errors.proposed}
              directly_conveyancing={props.isProposedDirectConveyancing}
              forceError={props.forceError}
            />
          )}
        </div>
        {props.displayValuation && <>
            <Separator variant="dashed" style={{margin:"32px 0"}}/>
            <div>
              <P2TextDescription color='#000' size='1.5rem' title={<P2TextLabel bold="700" color={"#000"} label={'Valuation options for stamp duty'}/>} description={'Stamp duty is payable on the change in ownership of HDB flat. Stamp duty payable is based on the Stamp Duties Act which is under the purview of Inland Revenue Authority of Singapore (IRAS). For the change in ownership, stamp duty may be payable. The amount of stamp duty payable will be based on the market value of the flat.'}/>
              <ValuationStampDutyForm forceError={props.forceError} setFormValue={props.setFormValue} conveyancing_values={props.conveyancing_values} errors={props.errors}/>
            </div>
        </>}
      </div>
      {props.isDocumentRequested && 
        <>
          <Separator variant='solid'/>
          <ReviewConveyancingDocument forceError={props.forceErrorDocuments} getAdditionalCheckbox={getAdditionalCheckbox} required_document_list={props.documentList} documentation_values={props.documentation_values} SetDocumentationValue={props.SetDocumentationValue} applicationId={props.applicationId} singpassToken={props.singpassToken} uinfin={props.uinfin}/>
        </>
      }
   </>
  }

  //login is outgoing
  return (
    <>
      <p hidden aria-hidden>3</p>
      <div className='px-4 pt-4 pb-5'>
        <P2TextDescription color='#000' title='Conveyancing' />
        {/* remove discharge of current loan when not private and hdb loan */}
        {!(!isPrivate && !isHDB) && <div className='mt-4 d-flex flex-column gap-3'>
          <TextInfo variant='column' title={`Legal representation for Current Owners' ${props.isCurrentDirectConveyancing ? "conveyancing process" : "discharge of current loan"}`} description={
            <div style={{ marginTop: 5 }}>
              {isMainOutgoing && isPrivate && <ReviewPrivateSolicitor private_solicitor={props.conveyancing_values.current.private_solicitor}/>}
              {isMainOutgoing && isHDB && <ReviewHdbSolicitor/>}
              {!isMainOutgoing && solicitorTypeItems.find(e=>e.value === props.conveyancing_values.current_solicitor_type)?.title }
            </div>
          } />
        </div>}
        {conveyancingSolicitorComponent('current')}

        {props.differentOutgoingOwnerSolicitorNotSelected && 
          <div style={{marginTop: "16px"}}> 
            <P2Checkbox forceError={false} variant={"default"} isActive={props.conveyancing_values.outgoing_different_solicitor} onClick={props.processOutgoingDifferentSolicitor} description={<P2TextLabel required label={<span className='m-0'>Outgoing owner is represented by a different solictor as above.</span>} />} />
            {props.conveyancing_values.outgoing_different_solicitor &&             
              <div style={{margin:"16px 0 0"}}>
                <Dropdown disabled={false} tooltipContent={<span style={{color: "#212529", lineHeight: "1.5rem", fontSize: "1rem"}}>You would be required to engage a lawyer for the following,<div>1) Discharge of current mortgage loan</div><div>2) Obtaining fresh mortgage loan</div><div>3) Conveyancing for the ownership change (current owners)</div><div>4) Conveyancing for the ownership change (proposed owners)</div><br /><div>The change in flat ownership is a conveyancing process. As a recommendation, having the same lawyer acting for the process would expedite and reduce the liaising with multiple parties.</div></span>} hasTooltip setSelectedDropdown={handleOutgoingConveyancingSolicitor} selectedDropdown={props.conveyancing_values.outgoing_solicitor_type} label={"Legal representation for outgoing owners’ conveyancing process"} placeholder='Please indicate lawyer type' required items={processLegalRepresentationDropdownForOutgoing}/>
                <LegalRepresentationSegment user_type={"outgoing"} legalRepresentation={props.conveyancing_values.outgoing} solicitor_type={props.conveyancing_values.outgoing_solicitor_type} ConveyancingSetFormValue={props.setFormValue} ConveyancingErrors={props.errors.outgoing} directly_conveyancing={true}/>
              </div>}
          </div>
        }

        {/* FOR SOLE OWNERSHIP ONLY */}
        {props.isSoleOwnership && <>
          <TextInfo variant='column' title={"Proposed Holding Type"} description={
              <div style={{ marginTop: 5 }}>
                Sole Ownership
              </div>
            } />
        </>}

       {!props.isSoleOwnership && <>
          {props.conveyancing_values.proposed_same_solicitor && !isLoginOutgoing && <>
            <Dropdown disabled={false} hasTooltip tooltipContent={<span style={{color: "#212529", lineHeight: "1.5rem", fontSize: "1rem"}}>You would be required to engage a lawyer for the following,<div>1) Discharge of current mortgage loan</div><div>2) Obtaining fresh mortgage loan</div><div>3) Conveyancing for the ownership change (current owners)</div><div>4) Conveyancing for the ownership change (proposed owners)</div><br /><div>The change in flat ownership is a conveyancing process. As a recommendation, having the same lawyer acting for the process would expedite and reduce the liaising with multiple parties.</div></span>} style={{marginTop:32}} setSelectedDropdown={handleConveyancingSolicitorType} selectedDropdown={props.conveyancing_values.proposed_solicitor_type} label={`Legal representation for Outgoing Owners' conveyancing process`} placeholder='Please indicate lawyer type' required items={processLegalRepresentationDropdown}/>
            <div className='mt-3'>
              {isProposedHDB && <HdbSolicitorForm variant='conveyancing' ConveyancingSetFormValue={handleConveyancingSolicitor} user_type={"proposed"} legal_representation={props.conveyancing_values.proposed}/>}
              {isProposedPrivate && <P2Accordion defaultOpen={true} title={<P2TextLabel bold="700" label={"Private Lawyer"} />}>
                <PrivateSolicitorForm variant='review' ConveyancingSetFormValue={handleConveyancingSolicitor} user_type={"proposed"} legal_representation={props.conveyancing_values.proposed} errors={props.errors.proposed.private_solicitor}/>
              </P2Accordion>
              }
            </div>
          </>}
        </>}

        
      </div>
      
      {props.isDocumentRequested && 
        <>
          <Separator variant='solid'/>
          <ReviewConveyancingDocument forceError={props.forceErrorDocuments} getAdditionalCheckbox={getAdditionalCheckbox} required_document_list={props.documentList} documentation_values={props.documentation_values} SetDocumentationValue={props.SetDocumentationValue} applicationId={props.applicationId} singpassToken={props.singpassToken} uinfin={props.uinfin}/>
        </>
      }
    </>
  )
}

export default ReviewConveyancing
